/* Horizontale scroller voor de ts-secties: vorige/volgende-knoppen en een voortgangsbalk.
   Markup: <ts-scroller> met [data-ts-track], optioneel [data-ts-prev], [data-ts-next] en [data-ts-progress] > span.
   Met setTrack(el) wisselt een andere track in (bijvoorbeeld bij tabbladen). */
if (!customElements.get('ts-scroller')) {
    customElements.define('ts-scroller', class extends HTMLElement {
        connectedCallback() {
            /* Kan meerdere keren afgaan als het element in de DOM verplaatst wordt */
            if (this.initialized) return;
            this.initialized = true;
            this.update = this.update.bind(this);
            this.resizeObserver = new ResizeObserver(this.update);
            this.thumb = this.querySelector('[data-ts-progress] > span');

            this.querySelectorAll('[data-ts-prev]').forEach((b) => b.addEventListener('click', () => this.step(-1)));
            this.querySelectorAll('[data-ts-next]').forEach((b) => b.addEventListener('click', () => this.step(1)));

            this.setTrack(this.querySelector('[data-ts-track]'));
        }

        setTrack(track) {
            if (this.track) {
                this.track.removeEventListener('scroll', this.update);
                this.resizeObserver.unobserve(this.track);
            }
            this.track = track;
            if (!track) return;
            track.addEventListener('scroll', this.update, { passive: true });
            this.resizeObserver.observe(track);
            this.update();
        }

        /* Schuif een stap van één item (incl. gap) op */
        step(dir) {
            const item = this.track && this.track.firstElementChild;
            if (!item) return;
            const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
            const size = item.getBoundingClientRect().width + gap;
            const max = this.track.scrollWidth - this.track.clientWidth;
            let target = this.track.scrollLeft + dir * size;
            if (dir > 0 && this.track.scrollLeft >= max - 2) target = 0;
            if (dir < 0 && this.track.scrollLeft <= 2) target = max;
            this.track.scrollTo({ left: target, behavior: 'smooth' });
        }

        update() {
            if (!this.track) return;
            const { scrollLeft, scrollWidth, clientWidth } = this.track;
            const max = scrollWidth - clientWidth;
            this.toggleAttribute('data-scrollable', max > 2);
            if (!this.thumb) return;
            const ratio = scrollWidth ? Math.min(clientWidth / scrollWidth, 1) : 1;
            const progress = max > 0 ? scrollLeft / max : 0;
            this.thumb.style.width = `${ratio * 100}%`;
            this.thumb.style.transform = `translateX(${progress * (1 / ratio - 1) * 100}%)`;
        }
    });
}
